import { schema } from 'normalizr'

const topic = new schema.Entity('topic', undefined, {
  idAttribute: value => value.course,
})

const question = new schema.Entity(
  'question',
  {
    course_topics: topic,
  },
  { idAttribute: value => value.question.id }
)

const test = new schema.Entity('test', {
  quiz_questions: [question],
  event_quizzes: [topic],
})

export default test



// WEBPACK FOOTER //
// ./src/schemas/onlineTest.js